<template>
  <tbody>
  <tr :class="{more_info: isEditable}" @click="toggleOpen">
    <td class="first_data" :data-th="'IP Prefix' |translate">{{ item.ip_prefix }}</td>
    <td :data-th="'Operátor' | translate">{{ item.operator_name }}</td>
    <td></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="isEditable"
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteIpPrefix">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  <tr v-if="isOpen && isEditable" class="more_info_content open">
    <td class="first_data">
      <text-input
          :id="'ip-prefix-'+item.id"
          v-model="newValue"
          :required="true"
          ref="localityipprefixref">
        <translate class="translate">IP prefix</translate>
      </text-input>
    </td>
    <td></td>
    <td></td>
    <td><p>
      <input
          class="btn"
          type="submit"
          :value="'Uložit' | translate"
          @click.stop.prevent="emitUpdateIpPrefix">
    </p></td>
  </tr>
  </tbody>
</template>

<script>
export default {
  name: "IpPrefixesRow",
  props: {
    item: Object,
    isEditable: Boolean,
  },
  data: function() {
    return {
      isOpen: false,
      newValue: this.item.ip_prefix,
    }
  },
  methods: {
    toggleOpen(){
      if(this.isEditable){
        this.isOpen = !this.isOpen;
      }
    },
    emitDeleteIpPrefix() {
      this.$emit('deleteIpPrefix', [String(this.item.ip_prefix)]);
    },
    emitUpdateIpPrefix() {
      this.$emit('updateIpPrefix', this.item.id, this.newValue)
      this.close();
    },
    close(){
      this.isOpen = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/localities/locality/IpPrefixesRow.vue